import { put, takeLeading } from "redux-saga/effects";
import { HttpService, _ } from "src/services";

import { ReportProblemTypes } from "../types";
import { ReduxAction } from "../models";
import { Urls } from "src/constants";
import { toast } from "react-toastify";
import { ModalsAction, ReportProblemAction } from "../actions";

export function* ReportProblemSaga() {
    yield takeLeading(ReportProblemTypes.REQUEST_REPORT_PROBLEM, reportProblem);
}

function* reportProblem(action: ReduxAction) {

    try {

        const { id, model } = action?.payload;

        const api = Urls.program.issue(id);
        yield HttpService.Fetch(api, model);

        toast.success(_("reportSent"));
        yield put(ReportProblemAction.submitted());
        yield put(ModalsAction.hideReport());
    }
    catch {
        toast.error(_("errorOccured"));
        yield put(ReportProblemAction.submitted());
    }

}